import script from "./FamilyLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyLogin.vue?vue&type=script&setup=true&lang=js"

import "./FamilyLogin.vue?vue&type=style&index=0&id=298a5848&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-298a5848"]])

export default __exports__